module.exports = __webpack_public_path__ + "img/setUpCards_3.f561708a.jpg";